import React, {useState, useMemo, useRef} from 'react';
import {View, Dimensions, TextInput, TouchableOpacity} from 'react-native';
import EStyleSheet from "react-native-extended-stylesheet";

import AppText from "../../../components/AppText";
import AppButton from "../../../components/AppButton";
import {basicStyles} from "../../../styles/basic";
import {textStyles} from "../../../styles/text";
import ScreenOverlay from "../../../components/ScreenOverlay";
import ContentSection from "../../../components/ContentSection";
import {inputStyles} from "../../../styles/input";
import {useDarkMode} from "../DarkModeContext";

function CreateNewNoteModal({handleClose, handleSubmit}) {
    const [noteContent, setNoteContent] = useState('');
    const noteInputRef = useRef(null);
    const {isDarkMode, theme} = useDarkMode();

    const screenWidth = useMemo(() => {
        return Dimensions.get('window').width
    }, [])

    return (
        <ScreenOverlay
            style={{position: 'fixed', left: screenWidth >= 630 ? 80 : 0, width: 'auto'}}
            onClick={() => {
            handleClose();
        }}>
            <ContentSection
                style={[styles.contentWrapper, isDarkMode && {backgroundColor: theme.background, borderColor: theme.border}]}
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <AppText style={[textStyles.pageTitle, {marginBottom: 10}, isDarkMode && {color: theme.text}]}>
                    Create a New Private Note
                </AppText>
                <TouchableOpacity
                    activeOpacity={1}
                    onPress={() => {
                        if (noteInputRef.current) {
                            noteInputRef.current.focus();
                        }
                    }}
                    style={[inputStyles.inputWrapper, styles.wrapperStyle, isDarkMode && {backgroundColor: theme.inputBg, borderColor: theme.inputBorder}]}
                >
                    {
                        !noteContent ?
                            <AppText style={[styles.notePlaceholder, isDarkMode && {color: theme.textSecondary}]}>
                                Write your note...
                            </AppText>
                            : null
                    }
                    <TextInput
                        ref={noteInputRef}
                        multiline={true}
                        numberOfLines={5}
                        style={[inputStyles.input, styles.noteInput, isDarkMode ? {color: theme.text} : {}]}
                        onChangeText={value => {
                            setNoteContent(value)
                        }}
                        value={noteContent}
                    />
                </TouchableOpacity>
                <View style={[basicStyles.flexRow, basicStyles.justifyContentFlexEnd, {marginTop: 20}]}>
                    <AppButton
                        label="Cancel"
                        action={handleClose}
                        style={{marginRight: 10}}
                        theme="transBlue"
                    />
                    <AppButton
                        label="Confirm"
                        action={() => {
                            handleSubmit(noteContent);
                        }}
                        style={{marginRight: 10}}
                        disabled={!noteContent}
                    />
                </View>
            </ContentSection>
        </ScreenOverlay>
    );
}

export default CreateNewNoteModal;

const styles = EStyleSheet.create({
    contentWrapper: {
        padding: 32,
        width: 600,
        maxWidth: '100%'
    },
    wrapperStyle: {
        height: 'auto',
        minHeight: 140,
        position: 'relative',
        padding: 0,
    },
    noteInput: {
        fontSize: 17,
        minHeight: 138,
        textAlignVertical: 'top',
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
    },
    notePlaceholder: {
        position: 'absolute',
        top: 17,
        left: 16,
        color: '#9BA8CA',
        fontSize: 17,
        pointerEvents: 'none',
    },
});